<div
  class="surface-card flex justify-content-center p-5 m-3 shadow-1 border-round"
>
  <div class="grid flex align-items-center justify-content-center card">
    <div class="col-10 font-medium text-2xl text-700 mb-3">
      <i class="pi pi-inbox"></i>
      Caja Registradora
    </div>
    <div class="col-1">
      <button
        pButton
        pRipple
        icon="pi pi-lock-open"
        class="p-button-rounded p-button-primary"
        pTooltip="Abrir Caja"
        tooltipPosition="left"
        (click)="showOpenCashRegister = true"
        [disabled]="!canOpenCashRegister"
      ></button>
    </div>

    <div class="col-1">
      <button
        pButton
        pRipple
        icon="pi pi-unlock"
        class="p-button-rounded p-button-warning"
        pTooltip="Cerrar Caja"
        tooltipPosition="left"
        (click)="showCloseCashRegister = true"
        [disabled]="!canCloseCashRegister"
      ></button>
    </div>

    <div class="text-500 col-12 mb-5">Datos asociados a tu punto de venta.</div>

    <ul class="col-12 list-none p-0 m-0">
      <li
        *ngFor="let item of cashRegisterCard; let i = index"
        class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
      >
        <div class="text-500 w-2 md:w-5 font-medium">
          {{ item.label }}
        </div>
        <div
          *ngIf="
            item.label !== 'Saldo Inicial' &&
            item.label !== 'Saldo Físico' &&
            item.label !== 'Ventas Efectivo' &&
            item.label !== 'Reembolso'
          "
          class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
        >
          {{ item.value }}
        </div>
        <div
          *ngIf="
            item.label === 'Saldo Inicial' ||
            item.label === 'Saldo Físico' ||
            item.label === 'Ventas Efectivo' ||
            item.label === 'Reembolso'
          "
          class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
        >
          {{ (item.value !== '-' ) ? ( item.value | currency: 'PEN' ) : ( item.value )}}
        </div>
      </li>
    </ul>
  </div>
</div>

<ng-container *ngIf="showOpenCashRegister">
  <pg-cash-register-open
    (close)="showOpenCashRegister = false"
  ></pg-cash-register-open>
</ng-container>

<ng-container *ngIf="showCloseCashRegister">
  <pg-cash-register-close
    (close)="showCloseCashRegister = false"
  ></pg-cash-register-close>
</ng-container>
